import * as React from 'react';
import { Props } from 'react';

import './DialogView.scss';
import i18next from 'i18next';

interface VisaDialogViewProps extends Props<VisaDialogView> {

}

export class VisaDialogView extends React.Component<VisaDialogViewProps> {
    render() {
        return (
            <div className='dialog-container'>
                <div className='dialog-client-message'>
                    {i18next.t('visa_requirement')}
                </div>
                <div className='clearfix' />
                <div className='dialog-bot-message'>
                    {i18next.t('which_country')}
                </div>
                <div className='clearfix' />
                <div className='dialog-client-message'>
                    {i18next.t('to_the_usa')}
                </div>
                <div className='clearfix' />
                <div className='dialog-bot-message'>
                    <div dangerouslySetInnerHTML={{ __html: i18next.t('visa_answer') }} />
                    <div className='visa-dialog-more-button'>
                        {i18next.t('read_more')}
                    </div>
                </div>
                <div className='clearfix' />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CleverBot/Home/Dialogs/VisaDialogView.tsx